module.exports = __webpack_public_path__ + "static/media/gcdef_10020.47bec3b1.ico";